module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mu-checkbox",
    class: {
      'label-left': _vm.labelLeft, 'disabled': _vm.disabled, 'no-label': !_vm.label
    },
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseup": _vm.handleMouseUp,
      "mouseleave": _vm.handleMouseLeave,
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchEnd,
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClick($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.nativeValue,
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, _vm.nativeValue) > -1 : (_vm.inputValue)
    },
    on: {
      "change": _vm.handleChange,
      "__c": function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.nativeValue,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.inputValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }
    }
  }), _vm._v(" "), (!_vm.disabled) ? _c('touch-ripple', {
    staticClass: "mu-checkbox-wrapper",
    attrs: {
      "rippleWrapperClass": "mu-checkbox-ripple-wrapper"
    }
  }, [(_vm.label && _vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-checkbox-icon"
  }, [(!_vm.checkedIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-uncheck mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.uncheckIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-checked mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.uncheckIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-uncheck",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.uncheckIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkedIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-checked",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.checkedIcon
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.label && !_vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "mu-checkbox-wrapper"
  }, [(_vm.label && _vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-checkbox-icon"
  }, [(!_vm.checkedIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-uncheck mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.uncheckIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-checked mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.uncheckIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-uncheck",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.uncheckIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkedIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-checked",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.checkedIcon
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.label && !_vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe3bae9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/checkbox/checkbox.vue
// module id = 456
// module chunks = 1